<template lang="pug">
  v-autocomplete(
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
    @input="$emit('input', $event)"
  )

    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")

    template(v-slot:append-item)
      div(v-intersect="onIntersect")
</template>

<script>
export default {
  name: 'VAutocompleteMore',
  props: {
    value: { type: [Object, Array, Number, String], default: null },
  },
  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.$emit('load-more-items');
      }
    },
  },
};
</script>
